import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, Pagination } from '@mui/material'
import { applicationStatus, SITE_STATUS } from './constants'
import { useStyles } from './style'
import { PROGRAM_KEY, FAMILY_KEY } from '../../constants/common'

function ApplicationList(props) {
  const classes = useStyles()
  const pageSize = 10
  const [selectedStatus, setSelectedStatus] = useState('')
  const [applicationList, setApplicationList] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [pageNum, setPageNum] = useState(1)
  const showApplicationSiteId = [PROGRAM_KEY.APS_RBP, PROGRAM_KEY.PSEG_LI, PROGRAM_KEY.SWELL]
  const isApplicationSiteId = showApplicationSiteId.includes(props.programKey) || props.familyKey === FAMILY_KEY.CT_ESS

  useEffect(() => {
    if (props.programKey !== '') {
      const defaultStatus = applicationStatus(props.programKey, props.familyKey, props.workflow)[0].value
      setSelectedStatus(defaultStatus)
    }
  }, [props.programKey, props.familyKey, props.workflow])

  useEffect(() => {
    let applicationIds = []
    if (props.familyKey === FAMILY_KEY.CT_ESS) {
      applicationIds = _.get(props.applicationListDetails, 'applications_info', [])
    } else {
      applicationIds = _.get(props.applicationListDetails, 'data', [])
    }
    const totalApplicationCount = _.get(props.applicationListDetails, 'total_count', 0)
    setApplicationList(applicationIds)
    setTotalCount(Math.ceil(totalApplicationCount / pageSize))
  }, [props.applicationListDetails, props.familyKey])

  useEffect(() => {
    if (props.programKey !== '' && selectedStatus !== '') {
      props.getApplicationList(pageNum, selectedStatus)
      props.setApplicationId('')
      props.setApplicationStatus(selectedStatus)
    }
  }, [selectedStatus, pageNum, props.programKey])

  const handleOnChange = (e) => {
    setPageNum(1)
    setSelectedStatus(e.target.value)
  }

  const handleApplicationClick = (applicationId, programId) => {
    props.setApplicationId(applicationId)
    if (props.familyKey === FAMILY_KEY.CT_ESS) {
      props.getApplicationDetail(applicationId, programId)
    } else {
      props.getApplicationDetail(applicationId, '')
    }
  }

  const StatusDropDown = () => {
    return (
      <FormControl className={classes.formControl} variant="standard">
        <InputLabel className={classes.inputLabel}>Show Applications :</InputLabel>
        <Select
          id="application-list"
          value={selectedStatus}
          onChange={handleOnChange}
          classes={{ select: classes.selectRoot }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
            getContentAnchorEl: null
          }}
        >
          {applicationStatus(props.programKey, props.familyKey, props.workflow).map(obj => (
            <MenuItem value={obj.value} classes={{ root: classes.menu }}>
              <Box className={classes.optionsWrapper}>
                {(props.programKey !== PROGRAM_KEY.PSEG_LI && props.familyKey !== FAMILY_KEY.CT_ESS) && <span className={classes.dot} style={{ backgroundColor: obj.color }}></span>}
                <Typography className={`${classes.options} ${(props.programKey !== PROGRAM_KEY.PSEG_LI && props.familyKey !== FAMILY_KEY.CT_ESS) ? '' : classes.m0}`}>{obj.label}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl >
    )
  }

  const List = () => {
    return applicationList.map(obj => {
      return (
        <Typography className={`${classes.listBox} ${obj.application_id === props.applicationId ? classes.activeBox : ''}`} onClick={() => handleApplicationClick(obj.application_id, obj.program_id)}>
          {isApplicationSiteId ? `${obj.application_id}_${obj.site_id}` : obj.site_id}
        </Typography>
      )
    })
  }

  return (
    <Box className={classes.listContainer}>
      <Box className={classes.listWrapper}>
        <Box className={classes.list}>
          <StatusDropDown />
          <Typography className={classes.title}>
            {isApplicationSiteId ? 'Applications by Application ID_Site ID' : 'Applications by Site ID'}
          </Typography>
          <List />
        </Box>
        <Pagination
          count={totalCount}
          shape="rounded"
          size="small"
          page={pageNum}
          className={classes.pagination}
          onChange={(event, newPage) => {
            setPageNum(newPage)
          }}
        />
      </Box>

    </Box>
  )
}

ApplicationList.defaultProps = {
  setApplicationId: () => { },
  applicationListDetails: {}
}

export default ApplicationList